import React from 'react';
import { useSelector } from 'react-redux';
import Translation from "../../shared/Translation";
import { getMainEvent } from '@b/checkout/selectors/event';

export const VenueInfo = () => {
    const { venues } = useSelector((state) => state?.venue);
    const event = useSelector(getMainEvent);

    const venue = venues?.[event?.event_id ?? ''];

    return (
        <div className="page__contact">
            <div className="page-contact__outer">
                <div className="page-contact__inner">
                    <h2 className="page__contact__org-title">
                        <Translation>
                            {'checkout__venue_details'}
                        </Translation>
                    </h2>
                    <div className="page__venue-info__title">
                        {venue?.name}
                    </div>
                    {venue?.address?.address_line_1 && (<p className="page__venue-info__description">
                        {venue?.address?.address_line_1}
                    </p>)}
                    {(venue?.address?.city || venue?.address?.region || venue?.address?.postal_code) && (<p className="page__venue-info__description">
                        {`${venue?.address?.city ? venue?.address?.city + ', ' : venue?.address?.city} ${venue?.address?.region} ${venue?.address?.postal_code}`}
                    </p>)}
                </div>
            </div>
        </div>
    )
};
